export const routerPaths = {
	home: "/",
	floorPlanLanding: "/floor-plan",
	kitchenLanding: "/kitchen-planner",
	roomLanding: "/room-planner",
	interior3dLanding: "/interior-3d",
	wardrobeLanding: "/wardrobe-planner",
	elevationsLanding: "/wall-elevations",
	estimateLanding: "/renovation-estimate",
	emailConfirm: "/email-confirm",
	login: "/login",
	passwordReset: "/password-reset",
	passwordResetConfirm: "/password-reset/confirm",
	register: "/register",
	admin: "/admin",
	blog: "/blog",
	blogArticle: "/blog/:article",
	blogArticleUrl: (slug: string, id: string) => `/blog/${slug}-${id}`,
	planner: "/planner",
	editor2d: "/editor/2d",
	editor3d: "/editor/3d",
	editorElevations: "/editor/elevations",
	editorEstimate: "/editor/estimate",
	projects: "/projects",
	furnitureGenerator: "/generator/furniture",
	features: "/#features",
	contacts: "/#contacts",
} as const;
